<div *ngIf="isLoading" [ngClass]="{ 'loader-overlay': fullscreen, 'loader-inline': !fullscreen }">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Chargement...</span>
  </div>
</div>
